import { allSettledCompat } from './adapterHelper';
import { IAdapter, ITrackParams } from './types';

export class AdapterManager {
    private adapters: Map<string, IAdapter> = new Map();
    private configs: Map<string, any> = new Map();

    public register(adapter: IAdapter, config?: any) {
        this.adapters.set(adapter.name, adapter);
        this.configs.set(adapter.name, config);
    }

    public unregister(name: string) {
        this.adapters.delete(name);
        this.configs.delete(name);
    }

    public async initAll(): Promise<void> {
        if (!this.adapters || this.adapters.size === 0) {
            return;
        }

        const promises = Array.from(this.adapters.entries()).map(async ([name, adapter]) => {
            if (adapter.init) {
                try {
                    const config = this.configs.get(name);
                    await adapter.init(config);
                } catch (error) {
                    console.log('[AdapterManager:init] ', error);
                }
            }
        });

        await allSettledCompat(promises);
    }

    public async track(params: ITrackParams, eventName: string): Promise<void> {
        if (!this.adapters || this.adapters.size === 0) {
            return;
        }

        const promises = Array.from(this.adapters.values()).map(async (adapter) => {
            if (adapter.track) {
                try {
                    await adapter.track(params, eventName);
                } catch (error) {
                    console.log('[AdapterManager:track] ', error);
                }
            }
        });

        await allSettledCompat(promises);
    }

    public getAdapter(name: string): IAdapter | undefined {
        return this.adapters.get(name);
    }
}
